import styled from 'styled-components';

export const ViewWrapper = styled.div.attrs(() => ({
  itemScope: 'itemScope',
  itemType: 'http://schema.org/ImageObject',
}))`
  width: ${props => (props.width ? props.width : '100%')};
  height: 100%;
  padding-top: 105px;
  padding-bottom: 34px;
  overflow: scroll;
  background: url(/assets/checker-bg.gif) repeat top left;
`;

export const ViewWrapperVideo = styled(ViewWrapper).attrs(() => ({
  itemType: 'http://schema.org/VideoObject',
}))``;

export const Img = styled.img`
  display: block;
  max-width: 100%;
  margin: 5px auto;
`;

export const Video = styled.video`
  display: block;
  max-width: 80%;
  margin: 0 auto;
  /* Media queries */
  @media print {
    &::-webkit-media-controls {
      display: none;
    }
  }
`;

export const PdfWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  border: 0px;
  height: 100%;
  width: ${props => (props.width ? props.width : '100%')};
  background-color: #f9f9f9;
  padding-top: ${props => (props.isPreview ? '4px' : '80px')};
  padding-bottom: ${props => (props.isPreview ? '2px' : '34px')};
  z-index: 1;
  .react-pdf__Page {
    canvas {
      margin: 15px auto;
    }
  }
`;
